import { memo, useMemo } from 'react'
import { List, Map } from 'immutable'
import InlineSelect from '@aytm/lib/rfd-ui/components/basic/inline-select'
import { decodeText } from '@aytm/app/stats/lib/util/helpers'

import useComponentLayout from '../../states/useComponentLayout'
import useSelectedItems from '../../states/useSelectedItems'
import useFitListToTable from '../../states/useFitListToTable'

import { DEFAULT_DATA_HEIGHT, ROW_PADDING } from '../../config/CompareItems_const'

import { CompareItemsTableAddItemCell as TCompareItemsTableAddItemCell } from '../../types'

import style from './AddItemCell.module.scss'

export default memo(
  CompareItemsTableAddItem,
  (prevProps, nextProps) =>
    prevProps.width === nextProps.width &&
    prevProps.className === nextProps.className &&
    prevProps.cell === nextProps.cell
)
export function CompareItemsTableAddItem({
  className,
  width,
  cell
}: {
  className: string
  width: number
  cell: TCompareItemsTableAddItemCell
}) {
  const componentLayout = useComponentLayout()
  // the table is measured after its first paint, and this cell can draw before that
  const { dataHeight = DEFAULT_DATA_HEIGHT } = componentLayout.measures

  const selectedItems = useSelectedItems()

  const list = useFitListToTable(dataHeight + ROW_PADDING, componentLayout.measures.attributeColFullWidth)

  const fetchItemOptions = useMemo(
    () => (filterValue: string) =>
      List(
        cell.items
          .map((item, itemIndex) =>
            !filterValue || decodeText(item.text).toLowerCase().includes(filterValue.toLowerCase())
              ? Map({
                  value: itemIndex,
                  render: () => (
                    <>
                      <b className={style.selector__option__item_name}>
                        {cell.itemName} {item.position}.
                      </b>
                      <br />
                      {decodeText(item.text)}
                    </>
                  )
                })
              : null
          )
          .filter(item => Boolean(item))
      ),
    [cell.items, cell.itemName]
  )

  return (
    <div
      data-testid="stat-compare-items-add-item"
      className={`${className || ''} ${style.CompareItemsTableAddItem}`}
      style={{ flex: `0 0 ${width}px`, width: `${width}px` }}
      data-compare-items="add-item-cell"
    >
      <InlineSelect
        innerRef={list.selectRef}
        fetchOptions={fetchItemOptions}
        onSelect={(option: Map<string, number | (() => JSX.Element)>) => {
          const itemIndex = option.get('value') as number
          if (null != itemIndex) {
            selectedItems.addItem(itemIndex)
          }
        }}
        className={style.selector}
        value={null}
        onShow={list.onShow}
        maxHeight={list.maxHeight}
        filter={cell.items.length > 9}
      >
        Choose another {cell.itemName}
      </InlineSelect>
    </div>
  )
}
